// Placeholder for the actual conversational onboarding flow.
// The marketing landing at /<cohortSlug>/founder/onboarding is live. The 12-minute
// guided conversation lives at this URL once it is built.
import { Link } from "wouter";
import { Sparkles, ArrowLeft } from "lucide-react";
import { SIA } from "./sia-voice";
import { useCohort, fp } from "@/lib/founder-cohort";

export default function OnboardingBegin() {
  const { slug } = useCohort();
  return (
    <div className="max-w-2xl mx-auto px-6 py-12">
      <div className="bg-gradient-to-br from-[#FF5C00]/10 via-[#FF5C00]/5 to-transparent border border-[#FF5C00]/30 rounded-xl p-7">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-[#FF5C00]/20 border border-[#FF5C00]/40 flex items-center justify-center flex-shrink-0">
            <Sparkles className="w-5 h-5 text-[#FF5C00]" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-baseline gap-2 mb-1.5">
              <span className="text-sm font-bold">{SIA.displayName}</span>
              <span className="text-[11px] text-white/60">{SIA.role}</span>
            </div>
            <p className="text-sm text-white/85 leading-relaxed">
              The 12-minute onboarding conversation is not built yet. It will
              live on this page when it is ready. Your Advisor is being assigned
              now. You will hear from them within 48 hours.
            </p>
          </div>
        </div>
        <Link
          href={fp(slug)}
          className="inline-flex items-center gap-2 text-sm text-[#FF5C00] hover:text-[#FF5C00]/80 font-medium"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Command Center
        </Link>
      </div>
    </div>
  );
}
